import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { UsersRoutingModule } from './users-routing.module';
import { LayoutComponent } from './layout.component';
import { AddEditComponent } from './add-edit.component';
import { AgGridModule } from 'ag-grid-angular';
import { DealerPaymentGatewayComponent } from './dealer-payment-gateway/dealer-payment-gateway.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        UsersRoutingModule,
        AgGridModule
    ],
    declarations: [
        LayoutComponent,
        AddEditComponent
        // Non-standalone components only
        // DealerPaymentGatewayComponent
    ],
    // exports:[DealerPaymentGatewayComponent]
})
export class UsersModule { }